<template>
    <ShowControl  @revert="revertClick"  :title="title" ref="showControl">
    <div style="width: 90%;height: 85%;margin-top: 3%;overflow-x: hidden;overflow-y: auto;">
        <Loading v-if="isLoading"
                 style="width: 100%;height: 100%; margin: auto;position: absolute;top: 0; left: 0; bottom: 0; right: 0;background-color:rgba(255, 255, 255, 0.9);z-index: 999;" />
        <div v-loading="loading" style="display: flex;">
          <div class="invoicMain">
            <div class="invoiceHeader">
              <div class="invoiceHeader-left">
                <ul class="headerLeft" style="width: 40%;">
                  <li>
                    <img src="../../../images/huizhan.png"
                         alt="">
                  </li>
                  <li>
                    <label>机器编号：</label><span></span>
                  </li>
                </ul>
                <div class="headerMiddle">
                  <h1 v-if="invoiceForm.type==Global.VoteType.专票">上海增值税专用发票</h1>
                  <h1 v-if="invoiceForm.type==Global.VoteType.普票">上海增值税普通发票</h1>
                  <div class="line"></div>
                </div>
              </div>
  
              <ul class="headerRight">
                <li>
                  <label> 发票代码： </label><span>031002100611</span>
                </li>
                <li>
                  <label> 发票号码： </label><span>19060174</span>
                </li>
                <li>
                  <label> 开票日期： </label><span>{{invoiceForm.invoicingDate}}</span>
                </li>
                <li>
                  <label> 校&nbsp;&nbsp;验&nbsp;&nbsp;码： </label><span>00597 73917 27033 77140</span>
                </li>
              </ul>
            </div>
            <div class="invoiceBody">
              <div class="userInfo">
                <div class="buy">购买方</div>
                <ul>
                  <li>
                    <label>名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</label><span>{{invoiceForm.name}}</span>
                  </li>
                  <li>
                    <label>纳税人识别号：</label><span>{{invoiceForm.dutyParagraph}}</span>
                  </li>
                  <li>
                    <el-tooltip :content="`${invoiceForm.address}&nbsp;&nbsp;${invoiceForm.phone}`">
                      <div style="display: -webkit-box; -webkit-box-orient: vertical;-webkit-line-clamp: 1; overflow: hidden;"><label>地址、&nbsp;&nbsp;&nbsp;电话：</label><span>{{invoiceForm.address}}&nbsp;&nbsp;{{invoiceForm.phone}}</span></div>
                    </el-tooltip>
                  </li>
                  <li>
                    <label>开户行及账号：</label><span>{{invoiceForm.bank}}</span>
                  </li>
                </ul>
                <div class="password">密码区</div>
                <div class="pwdInfo">{{PasswordArea}}</div>
              </div>
              <div>
                <table class="GoodsTable"
                       cellpadding="0"
                       cellspacing="0">
                  <tr>
                    <td style="width: 24%">货物或应税劳务、服务名称</td>
                    <td style="width: 10%">规格型号</td>
                    <td style="width: 7%">单位</td>
                    <td style="width: 10%">数量</td>
                    <td style="width: 10%">单价</td>
                    <td style="width: 16%">金额</td>
                    <td style="width: 7%">税率</td>
                    <td style="width: 16%; border-right: none;">税额</td>
                  </tr>
                  <tr class="invoice-list">
                    <td>&nbsp;&nbsp;会展服务费</td>
                    <td></td>
                    <td>次</td>
                    <td>{{invoiceForm.count}}</td>
                    <td>{{String(invoiceForm.price).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</td>
                    <td>{{String(invoiceForm.cost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</td>
                    <td>{{invoiceForm.ticket}}%</td>
                    <td>{{String(invoiceForm.taxAmount).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</td>
                  </tr>
                  <tr class="total">
                    <td>合计</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr class="GoodsTotal">
                    <td>价税合计(大写)</td>
                    <td colspan="7">
                      <div style="width: 100%;display:flex">
                        <div type="text"
                             style="width: 60%">&nbsp;{{digitUppercase(invoiceForm.adValorem)}}</div>
  
                        <div type="text"
                             style="width: 30%"> (小写)&nbsp;¥&nbsp;{{String(invoiceForm.adValorem).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</div>
                      </div>
  
                    </td>
                  </tr>
                </table>
                <div class="userInfo">
                  <div class="buy">销售方</div>
                  <ul>
                    <li>
                      <label>名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</label><span>海丝博览会组委会</span>
                    </li>
                    <li>
                      <label>纳税人识别号：</label><span>92220108MA01GOFB09</span>
                    </li>
                    <li>
                      <el-tooltip :content="`广东省广州市越秀区东风西路158号广州国际经贸大厦&nbsp;&nbsp;020-84243969`">
                        <div style="display: -webkit-box; -webkit-box-orient: vertical;-webkit-line-clamp: 1; overflow: hidden;"><label>地址、&nbsp;&nbsp;&nbsp;电话：</label><span>广东省广州市越秀区东风西路158号广州国际经贸大厦&nbsp;&nbsp;020-84243969 </span></div>
                      </el-tooltip>
                    </li>
                    <li>
                      <label>开户行及账号：</label><span>招商银行</span>
                    </li>
                  </ul>
                  <div class="password">备注</div>
                  <div class="pwdInfo">{{invoiceForm.describe}}</div>
                </div>
              </div>
            </div>
            <ul class="invoicetFooter">
              <li>
                <label>收款人：刘智英</label>
              </li>
              <li>
                <label>复核：董晶晶</label>
              </li>
              <li>
                <label>开票人：杨云</label>
              </li>
              <li>
                <label>销售方：（章）</label>
              </li>
            </ul>
  
          </div>
            
          <div>
            <el-button type="primary"
                     @click="onsubmit()"
                     style=" margin-left:10px;">开具并发送</el-button>
          </div>
        </div>
      <!-- </el-dialog> -->
    </div>
  </ShowControl>
  </template>
    <script>
  import { mapState } from "vuex";
  import Loading from '../../Loading.vue';
  import ShowControl from "../../UserControl/ShowControl.vue"
  export default {
    components: {
      Loading,
      ShowControl
    },
    props: ["datas"],
    data () {
      return {
        loading: false,
        flowID: localStorage.getItem("flowID"),
        loding: false,
        isLoading: false,
        invoiceview: false,
        caseID: localStorage.getItem("caseId"),
        Invoice: {},
        invoiceForm:
        {
        },
        PasswordArea: '3+9956582+*4-5961+</9+88-41*629/<>483/-4<86325+<>9*83+9878-<+973+1*5*9-5952->1/399901/409/<82921>289972*870',
          title: '发票管理'
      };
    },
    computed: {
      ...mapState({
        Round: (state) => state.user.round,
        ChatShow:(state) => state.user.chatShows,
      }),
    },
    created () {
      this.GetInvoices()
    },
    mounted() {
      this.$refs.showControl.receiveValue(true);
    },
    methods: {
      revertClick(){
        this.$router.push("/InvoiceCard")
      },
      GetInvoices(){
        this.$http.get('Income/GetInvoices?id='+this.$route.query.id+'&caseID='+this.caseID).then((res) => {
            if (res.success) {
              this.invoiceForm = res.dynamicObj[0]
            } else {
              this.$message.warning(res.message)
            }
          })
      },
      // 金额数字转大写
      digitUppercase (price) {
        const fraction = ['角', '分']
        const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
        const unit = [
          ['元', '万', '亿'],
          ['', '拾', '佰', '仟']
        ]
        let num = Math.abs(price)
        let s = ''
        fraction.forEach((item, index) => {
          s += (digit[Math.floor(num * 10 * (10 ** index)) % 10] + item).replace(/零./, '')
        })
        s = s || '整'
        num = Math.floor(num)
        for (let i = 0; i < unit[0].length && num > 0; i += 1) {
          let p = ''
          for (let j = 0; j < unit[1].length && num > 0; j += 1) {
            p = digit[num % 10] + unit[1][j] + p
            num = Math.floor(num / 10)
          }
          s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
        }
  
        return s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整')
      },
      onsubmit () {
        if (this.flowID == this.Global.FlowList.实验总结) {
          this.$message.error("实验总结阶段，无法进行操作！");
          return;
        }
        this.isLoading = true;
        setTimeout(() => {
          let list = [{
            invoicetype: this.invoiceForm.type,
            uuid: this.invoiceForm.uuid == null ? this.uuid.guid() : this.invoiceForm.uuid,
            Cost: this.invoiceForm.cost,
            dutyParagraph: this.invoiceForm.dutyParagraph,
            state: this.Global.SModel.Create,
            phone: this.invoiceForm.phone,
            bank: this.invoiceForm.bank,
            describe: this.invoiceForm.describe,
            address: this.invoiceForm.address,
            sTTime: this.filter.formatDate(new Date()), groupId: this.Global.groupid,
            round: this.Round,
            type: "S_Invoice",
          }];
          this.$http.post("SModel/PushStrategy", this.Global.getsmodel(list)).then((res) => {
            if (res.success) {
              // this.Global.sendmsgmd(
              //   "财务部门",
              //   `开具了${this.invoiceForm.type == this.Global.VoteType.专票 ? '专票' : '普票'}`,
              //   1
              // );
              this.$store.commit("chatShow",{ isOperate : !this.ChatShow, chatValue: this.Global.OperateType.发票管理 }); 
              this.API.createTaskBar(this.Round, this.Global.EnumUserStatus.normal, '发票管理');
              this.isLoading = false;
              // this.$emit("InvoiceEdit")
              this.$router.push("/InvoiceCard")
            } else {
              return this.$message.error(res.message)
            }
          })
        }, 3000);
  
      },
    },
  };
    </script>
    
    <style scoped>
  ul,
  ul li {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  
  label {
    color: #9c5223;
  }
  
  .invoicMain {
    width: 90%;
  
    font-size: 14px;
    color: #000;
    padding: 20px;
    border: 2px solid #9c5223;
  }
  
  .invoiceHeader {
    height: 20%;
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
  }
  
  /* .headerLeft li:nth-child(1) {
    text-indent: 1em;
  } */
  
  .headerLeft li img {
    width: 20%;
    height: 20%;
  }
  
  .headerMiddle h1 {
    font-size:calc(100vw * 30 / 1920);
    color: #9c5223;
    font-family: "kaiti";
  }
  
  .line {
    height: 2px;
    border-top: #9c5223 1px solid;
    border-bottom: #9c5223 1px solid;
  }
  
  .headerRight li {
    line-height: 24px;
  }
  
  .invoiceBody {
    border: 1px solid #9c5223;
  }
  
  .userInfo {
    width: 100%;
    display: flex;
    align-items: center;
    height: 96px;
    border-bottom: 1px solid #9c5223;
  }
  
  .userInfo ul {
    width: 50%;
    margin: 0 5px;
    padding: 0;
  }
  
  .userInfo ul li {
    line-height: 24px;
  }
  
  .buy {
    width: 20px;
    border-right: 1px solid #9c5223;
    padding: 0 10px;
    text-align: center;
    height: 100%;
    display: flex;
    align-items: center;
    color: #9c5223;
  }
  
  .password {
    width: 20px;
    padding: 0 10px;
    border-right: 1px solid #9c5223;
    border-left: 1px solid #9c5223;
    text-align: center;
    height: 100%;
    display: flex;
    align-items: center;
    color: #9c5223;
  }
  
  .pwdInfo {
    flex: 1;
    padding-left: 5px;
  }
  
  .goodsInfo {
    height: 210px;
    margin: 0;
    padding: 0;
  }
  
  .goodsInfo li {
    display: flex;
    color: #9c5223;
    text-align: center;
  }
  
  .name {
    width: 260px;
    border-right: 1px solid #9c5223;
  }
  
  .spec {
    width: 140px;
    border-right: 1px solid #9c5223;
  }
  
  .qty {
    width: 108px;
    border-right: 1px solid #9c5223;
  }
  
  .unit,
  .taxRate {
    width: 65px;
    border-right: 1px solid #9c5223;
  }
  
  .qty,
  .price {
    width: 160px;
    border-right: 1px solid #9c5223;
  }
  
  .money {
    flex: 1;
    border-right: 1px solid #9c5223;
  }
  
  .taxAmount {
    flex: 1;
  }
  
  .GoodsTable {
    height: 210px;
    width: 100%;
    border-collapse: collapse;
  }
  .GoodsTable td {
    border-right: 1px solid #9c5223;
    color: #9c5223;
  }
  
  .GoodsTable tr:nth-child(1),
  .GoodsTable tr:nth-last-child(2) {
    height: 24px;
  }
  
  .GoodsTable tr:nth-last-child(1) {
    height: 34px;
  }
  
  .GoodsTable tr:nth-child(1) td {
    text-align: center;
  }
  
  .GoodsTotal {
    border-top: 1px solid #9c5223;
    border-bottom: 1px solid #9c5223;
  }
  
  .total td:nth-child(1) {
    text-align: center;
  }
  
  .invoicetFooter {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: space-between;
  }
  
  .invoicetFooter li {
    width: 25%;
  }
  .invoiceHeader-left {
    width: 67%;
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
  }
  .headerRight {
    margin-left: 28px;
  }
  .headerMiddle {
    margin-right: 15px;
  }
  </style>